export const list_api = {
  url: 'memberDataLists',
  title: "数据互通 列表",
  method: "post"
}
export const export_api = {
  url: 'memberListDownload',
  title: "数据互通 导出",
  method: "post"
}
export const upload_api = {
  url: 'memberListUpload',
  title: "数据互通 导入",
  method: "post"
}

// export const fileHeader_api = {
//   url: 'excelheadermemberdata',
//   title: "",
//   method: "get"
// }


// WEBPACK FOOTER //
// ./src/views/base/memberdata/desc.js